import type { MentiErrorOptions } from '@mentimeter/error-utils/error';
import { MentiError } from '@mentimeter/error-utils/error';

export class UncommonPropertyError extends MentiError {
  constructor(
    property: string,
    options?: Partial<MentiErrorOptions> | undefined,
  ) {
    const message = `Uncommon property: ${String(property)}`;
    super(message, {
      feature: 'compatibility-layer',
      ...options,
    });
    this.name = 'UncommonPropertyError';
  }
}
